export const CAMERA_TUNING = Object.freeze({
  distance: 8.8,
  height: 3.2,
  targetHeight: 1.15,
  stiffness: 8,
  fieldOfView: 72,
  boostFieldOfView: 80,
  collisionPadding: 0.35,
});
